import { useContext } from 'react';
import { TimerContext } from './TimerContext';

export const useTimer = () => {
    const ctx = useContext(TimerContext);
    if (!ctx) {
        throw new Error('useTimer must be used inside a TimerProvider');
    }
    return ctx;
};
